import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { validationmethod } from "src/app/shared/models/validationmethod";
import { CommonService } from "src/app/shared/services/common.service";

@Component({
    selector: "app-alert-lib-create-dialog",
    templateUrl: "./alert-lib-create-dialog.component.html",
    styleUrls: ["./alert-lib-create-dialog.component.scss"],
    standalone: false
})
export class AlertLibCreateDialogComponent implements OnInit {
  @ViewChild('exprBuilder') exprBuilder!: any;
  @Output() FormSubmitted = new EventEmitter<any>();
  form!: FormGroup;

  // ruleTypes = ["SDR", "DME", "IME", "Spike Detection"];
  // dataSources = ["EVDAS", "FAERS", "VigiBase", "Safety Database"];
  // periodicities = ["Weekly", "Monthly", "Quarterly"];
  statuses = ["Active", "Inactive"];
  titleText = "Create Alert Catalogue Rule";

  alertFields =[];

  alertOperators = [];
  groupOps = ['AND', 'OR'];
  formSubmitted = false;
  readableLogic = '';
   //key :- are lookuptype , assignTo :-  are property to which lookup need to be added
      lookups = [
      { key: "AlertRuleType", assignTo: "AlertRuleType" },
      { key: "DataSource", assignTo: "DataSource"},
      { key: "Periodicity", assignTo: "Periodicity" },
      // { key: "SignalSourcesV2", assignTo: "SignalSources" },
    ];
    AlertRuleType = [];
    DataSource = [];
    Periodicity = [];


  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AlertLibCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private validate: validationmethod,
    private commonService:CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
  ) {}

  ngOnInit(): void {
    this.fetchlookupvalueAlertFields();
    this.fetchLoookupValuesForOperators();
    this.getAllLookupValue();

    this.createform();
    console.log("inside crete component ")

    this.form.get("defaultRule")?.valueChanges.subscribe((v) => {
      const ex = this.form.get("exceptionAllowed");
      v ? ex?.enable() : ex?.disable();
    });

    if (this.data?.mode === "edit" && this.data?.rowData) {
      this.titleText = "Update Alert Catalogue Rule";
      this.updateform();
    }
  }

  createform() {
    this.form = this.fb.group({
      ruleType: ["", Validators.required],
      dataSource: ["", Validators.required],
      ruleName: ["", [Validators.required,this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]],
      description: ["",this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore],
     logic: [null, this.logicValidator()],
      periodicity: ["", Validators.required],
      defaultRule: [false],
      exceptionAllowed: [{ value: false, disabled: true }],
      active: [true],
    
    });
  }

logicValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const logic = control.value;

    // 1️⃣ No logic at all (null, undefined, or empty object)
    if (!logic) {
      return { emptyExpression: true };
    }

    // 2️⃣ Check if it's an object with empty rules array
    if (!logic.rules || logic.rules.length === 0) {
      return { emptyExpression: true };
    }

    // 3️⃣ Recursive validation for incomplete rules
    const hasInvalidRule = (node: any): boolean => {
      // Group
      if (node.rules && node.rules.length) {
        return node.rules.some((r: any) => hasInvalidRule(r));
      }

      // Leaf rule
      return (
        !node.metric_id ||
        !node.operator ||
        node.value === null ||
        node.value === undefined
      );
    };

    return hasInvalidRule(logic)
      ? { invalidExpression: true }
      : null;
  };
}


updateform() {
  const row = this.data.rowData;

  this.form.patchValue({
    ruleType: row.ruleType,
    dataSource: row.dataSource,
    ruleName: row.ruleName,
    description: row.description,
    logic: JSON.parse(row.logicExpression), // 👈 convert back to object
    periodicity: row.periodicity,
    defaultRule: row.defaultRule,
    exceptionAllowed: row.exceptionAllowed,
    active: row.status === 'Yes'   // convert status → boolean
   
  });
}


  onSubmit() {
  this.formSubmitted = true;
  this.form.markAllAsTouched();
  this.exprBuilder?.markAllAsTouchedDeep();
  this.form.get('logic')?.updateValueAndValidity();

  if (this.form.invalid) {
    return;
  }

  this.FormSubmitted.emit({ value: this.form.value });
    console.log(this.form.value);
    console.log(this.form.value.logic);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

onExpressionChange(expr: any) {
  this.readableLogic = expr ? this.toReadableText(expr) : '';
}

errorStateMatcher = {
  isErrorState: (control: any) => {
    return !!(
      control &&
      control.invalid &&
      (
        this.formSubmitted || 
        (control.touched && control.dirty)
      )
    );
  }
};

  /** Convert JSON to human readable text recursively */
  toReadableText(node: any): string {
    if (node.rules) {
      return '(' + node.rules
        .map(r => this.toReadableText(r))
        .join(` ${node.condition} `) + ')';
    }
    const operatorLabel = this.getOperatorLabel(node.operator);

    return `${node.fieldName} ${operatorLabel} ${node.value}`;
  }


    fetchlookupvalueAlertFields() {
    this.spinner.start();
    this.commonService.getlookupVauleByLookUpType('AlertFields').subscribe({
        next: (result: any) => {

        this.alertFields = result.map((item: any) => ({
        metric_id: item.lookupvalue,
        fieldName: item.lookupvalue,   // display
        value: item.lookupvalue    // actual value
      }));
         console.log(this.alertFields);
         this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup AlertFields":`, err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
        
          this.spinner.stop();
        },
      });
  }

  fetchLoookupValuesForOperators() {
        this.spinner.start();
    this.commonService.getlookupVauleByLookUpType('Operator').subscribe({
        next: (result: any) => {

        this.alertOperators = result.map((item: any) => ({
        label: item.lookupvalue,
        value: item.lookupcode,   
      }));
         console.log(this.alertOperators);
         this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup AlertFields":`, err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          //         // this.loadGridData();
          this.spinner.stop();
        },
      });
  }

getOperatorLabel(value: string): string {
  return this.alertOperators.find(op => op.value === value)?.label || value;
}

 getAllLookupValue(){
    this.spinner.start();
     // Fetch all lookups (To add new lookup Mention In lookups[]  )
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;
          this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
          this.spinner.stop();
        },
      });
    });
    this.spinner.stop();
  }

}
